import InformationNaturalPersonForm from './InformationForm';

interface InfoNaturalPersonContainerProps {
    isDataPrevCreditWorker?: boolean;
    isSpecialCategory?: boolean;
}
const InformationNaturalPersonContainer: React.FC<InfoNaturalPersonContainerProps> = ({
    isDataPrevCreditWorker,
    isSpecialCategory
}) => {
    return (
        <InformationNaturalPersonForm
            isDataPrevCreditWorker={isDataPrevCreditWorker}
            isSpecialCategory={isSpecialCategory}
        />
    );
};
export default InformationNaturalPersonContainer;
